/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Grid, Row, Col } from 'react-bootstrap';
import s from './ServicesFooter.scss';
import { saveFooterHeight } from '../../actions/eservices';
import DistrictDetails from './DistrictDetails';
import WideLogo from './WideLogo';
import { portalMode } from '../../config';
import { PODLASKIE_MODE } from '../../constants'
import {
  layoutColorStyle,
  podlaskieLabelBackgroundColor,
  setFooterAndHeaderColors,
  TitleDict,
  bodyDict
} from '../utils/utils';
import ModalInfo from '../ModalInfo/ModalInfo';

class ServicesFooterClass extends React.Component {
  state = {
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},
    viewPopup: false,
    showChangeLabel: false,
    actualPopupType: 'rodo',
    fetchedHtmlContent: []
  }

  componentDidMount() {
    this.getFooterHeight();
    this.setTheme();

    const url = `${process.env.API_URL}/eservices/html_files`;
    fetch(url, {
        method: 'GET',
    })
    .then((response) => {
      if (response.status == 200) {
        return response.json();
      } else {
        throw new Error(`Failed to fetch: ${response.status} ${response.statusText}`);
      }
    })
    .then((data) => {
      this.setState({ fetchedHtmlContent: data }, () => this.checkIfShouldShowPopup());
    })
  }

  checkIfShouldShowPopup() {
    const termsOfUseItem = this.state.fetchedHtmlContent.find(item => item.type === 'termsOfUse');
    
    if (termsOfUseItem) {
      const acceptedVersion = localStorage.getItem('termsOfUseAcceptedVersion');
      
      if (!acceptedVersion || acceptedVersion !== termsOfUseItem.updatedAt) {
        this.setState({ viewPopup: true, actualPopupType: 'termsOfUse', showChangeLabel: true });
      }
    } else {
      localStorage.removeItem('termsOfUseAcceptedVersion');
    }
  }

  setTheme() {
    const {colors, sourceStyle, style} = setFooterAndHeaderColors('footer');
    this.setState({ colors, sourceStyle, style});
  }

  componentDidUpdate() {
    this.getFooterHeight();
  }
  getFooterHeight = () => {
    const foot = this.footer;
    const footHeight = foot.getBoundingClientRect().height;
    this.props.saveFooterHeight(footHeight);
  }

  getYear = () => {
    const d = new Date();
    const n = d.getFullYear();
    return n;
  };

  handleHide = () => {
    if (this.state.actualPopupType === 'termsOfUse') {
      const termsOfUseItem = this.state.fetchedHtmlContent.find(item => item.type === 'termsOfUse');
      
      if (termsOfUseItem) {
        localStorage.setItem('termsOfUseAcceptedVersion', termsOfUseItem.updatedAt);
      }
    }
    
    this.setState({ viewPopup: false, showChangeLabel: false });
  }

  handleShow = (popupType) => {
    this.setState({ viewPopup: true, actualPopupType: popupType })
  }

  render() {
    const buttonsStyle={...this.state.style, paddingLeft: '10px', paddingRight: '10px'};
    const matchedItem = this.state.fetchedHtmlContent.find(item => item.type === this.state.actualPopupType);

    let bodyTitle = matchedItem ? matchedItem.title : TitleDict[this.state.actualPopupType];
    if (matchedItem && this.state.actualPopupType === 'termsOfUse' && this.state.showChangeLabel) {
      bodyTitle = '<b><center>ZMIANA REGULAMINU</center></b> ' + bodyTitle;
    }

    const bodyText = matchedItem ? matchedItem.html : bodyDict[this.state.actualPopupType];
    return (
    <div>
      {
      portalMode == PODLASKIE_MODE ?
        <div style={{ backgroundColor: podlaskieLabelBackgroundColor, width: "100%", height:'10px'}}></div>
      : null
      }
      <footer ref={x => this.footer = x} style={this.state.style} className="servicesFooter my-bg footer" id="layout-footer">

        <Grid>
          <Row>
            <Col xs={12} sm={3} style={{ display: 'flex', justifyContent: 'center' }}>
              {
                this.props.prefix && this.props.arms ?
                  <img style={{ height: '60px' }} src={`${process.env.OLD_IHUB}/upload/herby/${this.props.arms}`} alt="Herb Urzędu" />
                  : null
              }
            </Col>
            <Col xs={12} sm={9} />
          </Row>
          <Row>
            <Col xs={12} sm={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
              {
                this.props.prefix !== undefined ?
                  <DistrictDetails prefix={this.props.prefix} style={this.state.style}/>
                  : null
              }
            </Col>
            <Col xs={12} sm={9} >
              {
                this.props.prefix !== undefined ?
                  <WideLogo prefix={this.props.prefix} style={this.state.style}/>
                  : null
              }
            </Col>
          </Row>
        </Grid>
        <div className="giap_link">
          {
            this.props.prefix !== undefined ?
            <a id="deklaracja" href={`/urzad/${this.props.prefix}/deklaracja-dostepnosci`} style={buttonsStyle}>
              Deklaracja dostępności
            </a>
              : null
          }
            <a id="privacyPolicy" href="#" style={buttonsStyle} onClick={() => this.handleShow('privacyPolicy')}>
              Polityka prywatności
            </a>
            <a id="termsOfUse" href="#" style={buttonsStyle} onClick={() => this.handleShow('termsOfUse')}>
              Regulamin Portalu
            </a>
            <a id="rodo" href="#" style={buttonsStyle} onClick={() => this.handleShow('rodo')}>
              Klauzula Informacyjna RODO
            </a>
        </div>
        <div className="giap_link">
          <a className="link" target="_blank" href="https://giap.pl/" style={this.state.style}>
            GIAP © {this.getYear()}
          </a>
          <b style={buttonsStyle}>Wersja 1.6.6</b>
        </div>
      </footer>
    {/* <div className="info-tech">
      <b>Uwaga! Trwają prace nad przebudową portalu. Portal może nie działać prawidłowo. Pracujemy nad przywróceniem wszystkich funkcjonalności.</b>
    </div> */}
      <ModalInfo
        title={bodyTitle}
        bodyText={bodyText}
        show={this.state.viewPopup}
        name="viewPopupModal"
        onSave={this.handleHide}
        colors={this.state.colors}
        onHide={this.handleHide}
      />
    </div>
    );
  }
}

const mapState = state => ({
  fontSize: state.runtime.fontSize,
  arms: state.eservices.arms,
});

const mapDispatch = {
  saveFooterHeight,
};

const ServicesFooter = connect(mapState, mapDispatch)(ServicesFooterClass);

export default withStyles(s)(ServicesFooter);



// WEBPACK FOOTER //
// src/components/ServicesFooter/ServicesFooter.js